<div>
    <span class="text">
        {{text}}
    </span>
    <img [pTooltip]="tooltipText"
            src="assets\icons\akar-icons_info-fill.svg" alt="alerta-campo-vazio" />
</div>
